import { render, staticRenderFns } from "./plural.vue?vue&type=template&id=67a6ac9c&scoped=true"
import script from "./plural.vue?vue&type=script&lang=js"
export * from "./plural.vue?vue&type=script&lang=js"
import style0 from "./plural.vue?vue&type=style&index=0&id=67a6ac9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6ac9c",
  null
  
)

export default component.exports